export enum GroupBuyEnum {
  GroupDetail = '/order/api/orders/group'
}
